/**
 * Get value of a CSS property for element as a string.
 * @param {HTMLElement} element
 * @param {string} property
 * @returns {string}
 */
export function getStringCssValue(element, property) {
  return getComputedStyle(element).getPropertyValue(property);
}

/**
 * Get value of a CSS property for element as a number without units.
 * @param {HTMLElement} element
 * @param {string} property
 * @returns {number}
 */
export function getNumberCssValue(element, property) {
  const value = getStringCssValue(element, property);
  // Intentionally use Number.parseFloat() instead of Number() because it ignores units
  return Number.parseFloat(value, 10);
}

/**
 * Get the value of a CSS property in pixels without units.
 * For example, a CSS variable defined as `rem` can be measured in `px`.
 * (Requires a layout so do once and save the value.)
 * @param {HTMLElement} element
 * @param {string} property
 * @returns {number}
 */
export function getActualCssValue(element, property) {
  // This relies on the fact that getComputedStyle will return pixels for "used values"
  // see: https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
  const testElement = document.createElement("div");
  testElement.style.backgroundPosition = getStringCssValue(element, property);
  // Need to inherit from the element we are testing to resolve CSS variables
  element.append(testElement);
  const value = getNumberCssValue(testElement, "background-position");
  testElement.remove();
  return value;
}
